module.exports = __webpack_public_path__ + "img/mobile_banner.31fecd9.png";